import * as React from 'react';
import styled from 'styled-components';

export interface DismissIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const DismissIcon: React.FC<DismissIconProps> = ({
  className,
  onClick,
  ...props
}) => (
  <svg
    className={className}
    onClick={onClick}
    viewBox="0 0 8.88 8.88"
    {...props}
  >
    <path d="M7.74.2,4.44,3.5,1.14.2A.65.65,0,0,0,.2.2a.65.65,0,0,0,0,.94l3.3,3.3L.2,7.74a.65.65,0,0,0,0,.94.66.66,0,0,0,.94,0l3.3-3.3,3.3,3.3a.66.66,0,1,0,.94-.94l-3.3-3.3,3.3-3.3a.66.66,0,0,0,0-.94A.65.65,0,0,0,7.74.2Z" />
  </svg>
);

export default styled(DismissIcon)`
  cursor: pointer;
  width: 12px;
  height: 12px;

  path {
    fill: ${({ theme }) => theme.colors.background};
    opacity: 1;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  &:hover {
    opacity: 0.75;
  }
`;
